export function createLogger(isDebug = true, instanceName, level = 'debug') {
    const colors = {
        debug: "#95a5a6",
        info: "#3498db",
        success: "#2ecc71",
        error: "#e74c3c",
        warn: "#f39c12"
    };

    const levels = {
        debug: 0,
        info: 1,
        success: 2,
        warn: 3,
        error: 4
    };

    const currentLevel = levels[level] || levels.debug;

    const logFn = (type, ...args) => {
        if (isDebug && levels[type] >= currentLevel) {
            console.log(
                `%cBF-LP-${instanceName}`,
                `background: ${colors[type]}; color: white; padding: 2px 5px; border-radius: 3px;`,
                ...args
            );
        }
    };

    return {
        debug: (...args) => logFn("debug", ...args),
        info: (...args) => logFn("info", ...args),
        success: (...args) => logFn("success", ...args),
        warn: (...args) => logFn("warn", ...args),
        error: (...args) => logFn("error", ...args),
    };
} 